import ApiClient from "../api/apiClient";

const UPLOAD_PROFILE_IMAGE = "/user/profile";
const USER_PROFILE_INFORMATION = "/user/profile";
const DELETE_PROFILE_IMAGE = "/user/profile";
const GET_ADDRESS = "/addresses";
const POST_ADDRESS = "/addresses";
const QUALIFICATION = "/qualifications";
const EXPERIENCES = "/experiences";
const AFFILIATIONS = "/affiliations";
const ENDORSEMENTS = "/endorsements";
const PROFESSIONAL_EXPERIENCE = "/professional-experience";
const RESUME = "/user/resume";
const PROFILE_SETTING = "/user/personal-information";
const PREFRERRED_REGISTRATION = "/user/preferred-registration";
const DASHBOARD = "/user/dashboard";

const getUserProfileInformation = () => {
  return ApiClient.get(USER_PROFILE_INFORMATION);
};

const updateUserProfileInformation = (data) => {
  return ApiClient.put(USER_PROFILE_INFORMATION, data);
};

const uploadProfileImage = (data) => {
  return ApiClient.post(UPLOAD_PROFILE_IMAGE, data);
};

const deleteProfileImage = () => {
  return ApiClient.delete(DELETE_PROFILE_IMAGE);
};

const getAddressInformation = () => {
  return ApiClient.get(GET_ADDRESS);
};

const postAddressInformation = (data) => {
  return ApiClient.post(POST_ADDRESS, data);
};

const createQualification = (data) => {
  return ApiClient.post(QUALIFICATION, data);
};

const getQualifications = () => {
  return ApiClient.get(QUALIFICATION);
};

const getQualificationById = (id) => {
  const url = QUALIFICATION + "/" + id;
  return ApiClient.get(url);
};

const updateQualification = (id, data) => {
  const url = QUALIFICATION + "/" + id;
  return ApiClient.put(url, data);
};

const deleteQualification = (id, data) => {
  const url = QUALIFICATION + "/" + id;
  return ApiClient.delete(url, data);
};

const createUserExperience = (data) => {
  return ApiClient.post(EXPERIENCES, data);
};

const getUserExperience = () => {
  return ApiClient.get(EXPERIENCES);
};

const getUserExperienceById = (id) => {
  const url = EXPERIENCES + "/" + id;
  return ApiClient.get(url);
};

const updateUserExperience = (id, data) => {
  const url = EXPERIENCES + "/" + id;
  return ApiClient.put(url, data);
};

const deleteUserExperience = (id, data) => {
  const url = EXPERIENCES + "/" + id;
  return ApiClient.delete(url, data);
};

const createUserAffiliations = (data) => {
  return ApiClient.post(AFFILIATIONS, data);
};

const getUserAffiliations = () => {
  return ApiClient.get(AFFILIATIONS);
};

const getUserAffiliationsById = (id) => {
  const url = AFFILIATIONS + "/" + id;
  return ApiClient.get(url);
};

const updateUserAffiliations = (id, data) => {
  const url = AFFILIATIONS + "/" + id;
  return ApiClient.put(url, data);
};

const deleteUserAffiliations = (id, data) => {
  const url = AFFILIATIONS + "/" + id;
  return ApiClient.delete(url, data);
};

const createUserProfessionalexperience = (data) => {
  return ApiClient.post(PROFESSIONAL_EXPERIENCE, data);
};

const getUserProfessionalexperience = () => {
  return ApiClient.get(PROFESSIONAL_EXPERIENCE);
};

const getUserProfessionalexperienceById = (id) => {
  const url = PROFESSIONAL_EXPERIENCE + "/" + id;
  return ApiClient.get(url);
};

const updateUserProfessionalexperience = (id, data) => {
  const url = PROFESSIONAL_EXPERIENCE + "/" + id;
  return ApiClient.put(url, data);
};

const deleteUserProfessionalexperience = (id, data) => {
  const url = PROFESSIONAL_EXPERIENCE + "/" + id;
  return ApiClient.delete(url, data);
};

const createEndorsements = (data) => {
  return ApiClient.post(ENDORSEMENTS, data);
};

const getEndorsementsBySearch = (search) => {
  return ApiClient.get(`${ENDORSEMENTS}/user?search=${search}`);
};

const getUserEndorsements = () => {
  return ApiClient.get(ENDORSEMENTS);
};

const getResume = () => {
  return ApiClient.get(RESUME);
};

const uploadResume = (data) => {
  return ApiClient.post(RESUME, data);
};

const updateProfileSettings = (data) => {
  return ApiClient.put(PROFILE_SETTING, data);
};

const updatePreferredRegistration = (data) => {
  return ApiClient.patch(PREFRERRED_REGISTRATION, data)
}

const dashboard = (data) => {
  let url = DASHBOARD;
  if (data) {
    url += `?start_date=${data?.start_date}&end_date=${data?.end_date}`;
  }
  if (data?.trend_year) {
    url += `&trend_year=${data?.trend_year}`;
  }
  return ApiClient.get(url);
};

export const userInfoService = {
  getUserProfileInformation,
  updateUserProfileInformation,
  uploadProfileImage,
  getAddressInformation,
  postAddressInformation,
  createQualification,
  getQualifications,
  getQualificationById,
  updateQualification,
  deleteQualification,
  createUserExperience,
  getUserExperience,
  getUserExperienceById,
  updateUserExperience,
  deleteUserExperience,
  createUserAffiliations,
  getUserAffiliations,
  getUserAffiliationsById,
  updateUserAffiliations,
  deleteUserAffiliations,
  createUserProfessionalexperience,
  getUserProfessionalexperience,
  getUserProfessionalexperienceById,
  updateUserProfessionalexperience,
  deleteUserProfessionalexperience,
  createEndorsements,
  getEndorsementsBySearch,
  getUserEndorsements,
  getResume,
  uploadResume,
  updateProfileSettings,
  dashboard,
  updatePreferredRegistration,
  deleteProfileImage
};
